<template>
    <b-modal id="bv-modal-pending"
            @hide="onHide"
             :hide-footer="true"
             :no-close-on-esc="true"
             :no-close-on-backdrop="true"
             :hide-header-close="true"
    >
        <template v-slot:modal-title>
            {{title}}
        </template>


        <div class="d-block text-center pb-3">
            {{message}}
        </div>
        <b-progress :value="100" :max="100" animated ></b-progress>
        <div class="pb-3"/>

    </b-modal>

</template>

<script>
    export default {
        name: "PendingDialog",
        async beforeMount() {
        },
        methods: {
            async onHide(ev){
                if(this.resolve != null){
                    this.resolve(null);
                    this.resolve = null;
                }
            },
            reset(){
                this.resolve = null;
            }
        },
        data: () => ({
            title:"title",
            message:"message",
            resolve: null,
        })
    }
</script>
